import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getProtocol.success: {
            return action.payload;
        }


        case constants.getProtocol.try:
        case constants.getProtocol.error:
        case constants.clearProtocol.toString(): {
            return {};
        }

        default:
            return state;
    }
}